// Vendors
import { useSelector } from 'react-redux';

// Selectors
import { selectSelectedLanguage } from '../../../reducers/language/languageSelectors';
import { selectUtmParams } from '../../../reducers/auth/authSelectors';

// Helpers
import { buildUrl } from '../../../lib/utmHelpers';

// Constants
import {
  recoveryForgotPasswordUrl,
  recoveryForgotEmailUrl,
  accountRecoveryUrl,
} from '../../../constants/appUrls';

// Components
import { Trans } from '../../../components/Trans';
import Icon from '../../../components/Icon/Icon';
import HoverSelectOption from '../../../components/HoverSelectOption/HoverSelectOption';
import { TxButton } from 'texkit-ui';

// Styles
import './whats-wrong.scss';

const WhatsWrong = ({ onBack }) => {
  const locale = useSelector(selectSelectedLanguage);
  const utmParams = useSelector(selectUtmParams);
  const langParam = `lang=${locale}`;

  const handleRecoveryOptions = (url) => {
    window.open(buildUrl(`${url}?${langParam}`, utmParams), '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="step sign-in-step">
      <h1 className="step-title">
        <Trans file="auth" id="whatsWrongHeader" />
      </h1>
      <div className="whats-wrong-options">
        <HoverSelectOption
          label={<Trans file="auth" id="forgotPasswordLabel" />}
          onClick={() => handleRecoveryOptions(recoveryForgotPasswordUrl)}
        />

        <HoverSelectOption
          label={<Trans file="auth" id="forgotUsernameLabel" />}
          onClick={() => handleRecoveryOptions(recoveryForgotEmailUrl)}
        />

        <HoverSelectOption
          label={<Trans file="auth" id="cantAccessAccountLabel" />}
          description={<Trans file="auth" id="cantAccessAccountDesc" />}
          onClick={() => handleRecoveryOptions(accountRecoveryUrl)}
        />
      </div>
      <div className="whats-wrong-back">
        <TxButton
          role="link" 
          tabIndex={0}
          className="whats-wrong-back-btn"
          onClick={onBack}
        >
          <Icon name="chevronLeft" />
          <span><Trans file="auth" id="backButton" /></span>
        </TxButton>
      </div>
    </div>
  );
};

export default WhatsWrong;
